import './MultiStringSelectInput.scss';
import { Button } from 'plume-ui';
import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { DependencyContainer } from '../../../../../../DependencyContainer';
import MultiItemInputModal from '../../../../../../components/MultiItemInputModal/MultiItemInputModal';
import { useFetchData } from '../../../../../../hooks/useFetchData';
import { activePartnerAtom } from '../../../../../../state';

const { metadataService } = new DependencyContainer();

interface MultiStringSelectInputProps {
  columnName: string;
  onChange?: (items: string[]) => void;
  title?: string;
  values?: string[];
  limitSelection?: number;
}

const MultiStringSelectInput = ({
  columnName,
  onChange,
  title,
  values,
  limitSelection,
}: MultiStringSelectInputProps) => {
  const { t } = useTranslation();
  const activePartner = useRecoilValue(activePartnerAtom);
  const [modalOpen, setModalOpen] = useState(false);

  const [loading, allowedValues] = useFetchData<string[], any>(
    async () => {
      if (!activePartner?.id) return;
      const data = await metadataService.getAllowedValues(
        activePartner.id,
        columnName,
      );
      return data?.sort((a, b) =>
        columnName.includes('firmware')
          ? b.localeCompare(a)
          : a.localeCompare(b),
      );
    },
    undefined,
    [activePartner],
    () => activePartner === undefined,
  );

  return (
    <>
      <Button
        styleVariant="secondary"
        onClick={() => setModalOpen(true)}
        classes={(current) => ({
          ...current,
          root: `${current.root} MultiStringSelectInput`,
        })}
      >
        {Boolean(values?.length) && (
          <div className="MultiStringSelectInput__countOverlay">
            {limitSelection === 1 && values && values[0]
              ? values[0]
              : t('multiItemInputModal.selected', { count: values!.length })}
          </div>
        )}
        {!Boolean(values?.length) &&
          t('monitorAdd.selectValues', {
            count: limitSelection,
          })}
      </Button>
      <MultiItemInputModal
        open={modalOpen}
        loading={loading}
        title={title || 'Select Values'}
        onRequestClose={(items) => {
          onChange?.(items);
          setModalOpen(false);
        }}
        values={values}
        allowedValues={allowedValues || []}
        limitSelection={limitSelection}
      />
    </>
  );
};

export default memo(MultiStringSelectInput);
